import React, { Fragment } from "react";
import get from "../../../../utils/get";
import { deBaseAFechaLocal } from "../../../../utils/Tools";

const DetalleCompraSection = (props) => {
  const {
    busquedaCDR,
    pasajerosMenores = [],
    pasajerosAdultos = [],
    producto = {},
    pasajerosPagantes,
    infoas,
  } = props;

  return (
    <ul className="info form-row">
      <li className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">Fecha In</li>
      <li className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 precio">
        {deBaseAFechaLocal(busquedaCDR.fechaIn)}
      </li>
      <li className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">Fecha Out</li>
      <li className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 precio">
        {deBaseAFechaLocal(busquedaCDR.fechaOut)}
      </li>
      <li className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
        Total Noches
      </li>
      <li className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 precio">
        {" "}
        {producto.cantidadNoches}
      </li>
      <li className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">Adultos</li>
      <li className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 precio">
        {pasajerosAdultos.length}
      </li>
      <li className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">Menores</li>
      <li className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 precio">
        {pasajerosMenores.length}
      </li>
      {infoas > 0 && (
        <Fragment>
          <li className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">Infoa</li>
          <li className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 precio">
            {infoas}
          </li>
        </Fragment>
      )}

      <li className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
        Huespedes Pagantes
      </li>
      <li className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 precio">
        {pasajerosPagantes}
      </li>
      {/* <li className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">Noches Free</li>
      <li className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 precio">0</li> */}
      <li className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
        Total Habitaciones
      </li>
      <li className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 precio">
        {get(producto, "habitaciones.length")}
      </li>
      <li className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">Regimen</li>
      <li className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 precio">
        {producto.habitaciones.map(
          (habitacion) =>
            `${get(habitacion, "regimenSeleccionado.denominacion", "")} `
        )}
      </li>
    </ul>
  );
};

export default DetalleCompraSection;



// WEBPACK FOOTER //
// ./src/components/Hoteles/ProcesoCompraCdr/FichaReservaCdr/detalleCompraSection.js